export const mockStoreQueries = {
  getStore() {
    const mockdata = {
      Id: 1307818,
      Name: 'Local URL mock store',
      DestinationUrl: 'http://mockurl.com',
      Description: null,
      Status: 'Approved',
      UseSslCheckout: true,
      BlockAggregators: false,
      Market: 'en-US',
      RecieveUpdates: false,
      ContactEmails: ['gikaro@microsoft.com'],
      AppealStatus: 'NoAppeal',
    };

    mockdata['@odata.context'] = 'https://mmcapi.ads-int.microsoft.com/ODataApi/Mmc/v3/Users(455008)/Customers(256234972)/Accounts(243337291)/$metadata#Stores/$entity';

    return Promise.resolve(mockdata);
  },
};
